



































































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import { getModule } from 'vuex-module-decorators'
import firebase from 'firebase'
import { db } from '../firebase/init'
import MainMixin from '../mixins/MainMixin'
import User from '../store/modules/user'
import { RequestOffType } from '../types'
import ViewRequestOff from '../components/requestsOff/ViewRequestOff.vue'
import CardList from '../components/layout/CardList.vue'

const requestsOff = collection<RequestOffType>('requestsOff')

@Component({
  components: {
    ViewRequestOff,
    CardList,
  },
})

export default class RequestOff extends Mixins(MainMixin) {
  tabs = [{ title: 'View Requests Off', value: 'view' }, { title: 'Add New', value: 'new' }]

  requestType = 'View Upcoming'

  requestDates = ['', '']

  allowedDates(d:string) {
    if (this.$store.state.location.data.blackoutDates.indexOf(d) !== -1) return false
    console.log('one')
    if (this.requestDates[0] !== '') {
      console.log('two')
      const nextDate = this.$store.state.location.data.blackoutDates.filter((x:string) => x > this.requestDates[0])[0]
      if (!nextDate) return true
      console.log('nd: ', nextDate)
      return d < nextDate
    }
    return true
  }

  minDate = dayjs().add(14, 'day')

  requestReason = ''

  loading = false

  get allRequestsOff() {
    if (this.requestType === 'View Upcoming') return this.upcomingRequestsOff
    return this.oldRequestsOff
  }

  oldRequestsOff:RequestOffType[] = []

  upcomingRequestsOff:RequestOffType[] = []

  selectedRequest:string|null = null

  activeRequest:RequestOffType|{id:string} = { id: '' }

  async checkRequestType() {
    if (this.requestType !== 'View Upcoming') {
      this.loadOldRequests()
    }
    this.activeRequest = { id: '' }
    this.selectedRequest = null
  }

  get secondaryTitle() {
    return 'Viewing Request'
  }

  get minDateComputed() {
    return this.minDate.format('YYYY-MM-DD')
  }

  clearDate() {
    this.requestDates = ['', '']
    this.minDate = dayjs().add(14, 'day')
  }

  updateDate(startDate: string) {
    console.log('go', startDate)
    if (this.requestDates[0]) {
      // const newDate:string = this.requestDates[0]
      this.minDate = dayjs(this.requestDates[0])
    }
  }

  updateDateHeader(d:string[]) {
    if (!d[0]) {
      return 'Select Date'
    } if (d[0] && !d[1]) {
      return `One Day: <b><u>${dayjs(d[0]).format('ddd MM/D/YY')}</b></u>`
    }
    const start = dayjs(d[0])
    const end = dayjs(d[1])
    return `<div style='width:55px;display:inline-block;'>From:</div> <b><u>${start.format('ddd MM/D/YY')}</b></u> <br /><div style='width:55px; display:inline-block'>To:</div> <u><b>${end.format('ddd MM/D/YY')}</b></u> (${end.diff(start, 'day') + 1} days.)`
  }

  async submitRequest() {
    this.loading = true
    if (!this.requestDates[0]) {
      this.loading = false
      return false
    } if (this.requestDates[0] && !this.requestDates[1]) {
      // eslint-disable-next-line prefer-destructuring
      this.requestDates[1] = this.requestDates[0]
    }
    console.log('making dates: ', this.requestDates)
    console.log('test: ', this.User)
    const request:RequestOffType = {
      user: this.uid,
      start: this.requestDates[0],
      end: this.requestDates[1],
      reason: this.requestReason,
      status: 'Unconfirmed',
      location: this.location,
      notes: '',
      created: new Date(),
    }
    await add(requestsOff, request)
    this.$toast.success('Success - We Received Your Request')
    this.EventBus.$emit('switch-tab', 'view')
    this.clearDate()
    this.requestReason = ''
    this.loading = false
    return true
  }

  oldRequestsLoaded = false

  async loadOldRequests() {
    await this.$bind('oldRequestsOff', db.collection('requestsOff').where('user', '==', this.uid).where('end', '<', dayjs(new Date()).format('YYYY-MM-DD')).orderBy('end', 'asc'))
    this.oldRequestsLoaded = true
  }

  mounted() {
    this.$bind('upcomingRequestsOff', db.collection('requestsOff').where('user', '==', this.uid).where('end', '>=', dayjs(new Date()).format('YYYY-MM-DD')).orderBy('end', 'asc'))
  }
}
